import { Dropdown } from '@platform/ui-library';
import { FC } from 'react';
import { useDesign } from '../../hooks';
import { useGlobalSettings } from '../../stores';
import { defaultTtsVoice, LanguageCode } from '../../types';

type TtsVoiceSelectorProps = {
  languageCode?: LanguageCode | null;
  onChange?: () => void;
};

export const TtsVoiceSelector: FC<TtsVoiceSelectorProps> = ({ languageCode, onChange }) => {
  const serialized = useDesign();
  languageCode ??= useGlobalSettings().language ?? LanguageCode.englishUs;
  const { ttsVoices, setSettings } = useGlobalSettings();
  const ttsVoice = ttsVoices[languageCode] ?? defaultTtsVoice;

  const nodeTtsVoices = Object.fromEntries(
    serialized.languages
      .filter(({ language, ttsFallBackVoice }) => {
        return ttsFallBackVoice && languageCode === language;
      })
      .map(({ ttsFallBackVoice }) => [ttsFallBackVoice, ttsFallBackVoice?.split('-').shift()])
  );

  const handleChange = (newTtsVoice: string) => {
    setSettings({ ttsVoices: { ...ttsVoices, [languageCode]: newTtsVoice } });
    onChange?.();
  };

  const currentValue = ttsVoice ?? defaultTtsVoice;

  if (Object.keys(nodeTtsVoices).length < 2) {
    return null;
  }

  return (
    <Dropdown
      className="selector"
      options={{
        default: (
          <>
            Default <small>(TTS)</small>
          </>
        ),
        ...nodeTtsVoices
      }}
      onChange={handleChange}
      value={currentValue}
    />
  );
};
